import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AssetModuleNavbar from "./AssetModuleNavbar";
import API_BASE_URL from "../config";

const QUICK_LINKS = [
  { icon: "bi-grid-3x3-gap-fill", label: " Assets", href: "/allassets", color: "#3d4c7a", bg: "#eef0f8" },
  //{ icon: "bi-plus-circle-fill",   label: "Add Asset",          href: "/addasset",          color: "#16a34a", bg: "#f0fdf4" },
  { icon: "bi-person-check-fill", label: "Allocations", href: "/allallocations", color: "#0369a1", bg: "#e0f2fe" },
  //{ icon: "bi-person-plus-fill",   label: "New Allocation",     href: "/newallocation",     color: "#0284c7", bg: "#f0f9ff" },
  { icon: "bi-arrow-left-right", label: "Transfers", href: "/alltransfers", color: "#9333ea", bg: "#faf5ff" },
  //{ icon: "bi-send-fill",          label: "New Transfer",       href: "/newtransfer",       color: "#7c3aed", bg: "#f5f3ff" },
  { icon: "bi-tools", label: "Maintenance", href: "/allmaintenance", color: "#d97706", bg: "#fffbeb" },
  //{ icon: "bi-wrench-adjustable",  label: "Raise Request",      href: "/newmaintenance",    color: "#b45309", bg: "#fef3c7" },
  { icon: "bi-clipboard2-check", label: "Audit Records", href: "/allauditrecords", color: "#0f766e", bg: "#f0fdfa" },
  //{ icon: "bi-clipboard2-plus",    label: "New Audit",          href: "/newauditrecord",    color: "#0d9488", bg: "#ccfbf1" },
  { icon: "bi-hourglass-split", label: "Pending Approvals", href: "/pendingapprovals", color: "#dc2626", bg: "#fef2f2" },
  //{ icon: "bi-clock-history",      label: "Approval History",   href: "/approvalhistory",   color: "#6b7280", bg: "#f3f4f6" },
  { icon: "bi-bar-chart-line", label: "Reports", href: "/asset-reports", color: "#be185d", bg: "#fdf2f8" },
  { icon: "bi-shop", label: "Vendors", href: "/vendors", color: "#1d4ed8", bg: "#eff6ff" },
  { icon: "bi-database-fill", label: "Field Master", href: "/asset-field-master", color: "#475569", bg: "#f1f5f9" },
];

export default function AdminAssetLanding() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [stats, setStats] = useState({ total: 0, available: 0, allocated: 0, inRepair: 0 });
  const [pendingCount, setPendingCount] = useState(0);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [statsRes, reqRes, recentRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/assets/stats`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_BASE_URL}/api/asset-requests?page=0&size=100`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_BASE_URL}/api/assets?page=0&size=5`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);

      if (statsRes.ok) setStats(await statsRes.json());

      if (reqRes.ok) {
        const d = await reqRes.json();
        const all = Array.isArray(d) ? d : d.content || [];
        setPendingCount(all.filter(r => (r.status || "").toLowerCase() === "pending").length);
      }

      if (recentRes.ok) {
        const d = await recentRes.json();
        setRecent(Array.isArray(d) ? d : d.content || []);
      }
    } catch { /* silent */ }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  useEffect(() => {
    const s = document.createElement("style");
    s.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
      .aal-root * { box-sizing: border-box; }
      .aal-root { font-family: 'Sora', sans-serif; background: #f4f6fb; min-height: 100vh; color: #1a1f36; }
      .aal-tile { background:#fff; border:1.5px solid #e8eaf0; border-radius:16px; padding:28px 20px;
        display:flex; flex-direction:column; align-items:center; gap:12px; cursor:pointer;
        transition:all 0.18s ease; text-align:center; text-decoration:none; color:inherit; }
      .aal-tile:hover { border-color:#080235; box-shadow:0 8px 24px rgba(8,2,53,0.1); transform:translateY(-3px); }
      .aal-tile-icon { width:52px; height:52px; border-radius:14px; display:flex; align-items:center; justify-content:center; font-size:22px; }
      .aal-stat { background:#fff; border:1px solid #e8eaf0; border-radius:14px; padding:20px 24px;
        display:flex; align-items:center; gap:16px; flex:1; min-width:160px; }
      .aal-stat:hover { box-shadow:0 4px 16px rgba(0,0,0,0.07); }
      @keyframes spin { to { transform:rotate(360deg); } }
      .aal-spinner { width:28px; height:28px; border-radius:50%; border:3px solid #e8eaf0; border-top-color:#080235; animation:spin 0.7s linear infinite; margin:60px auto; }
    `;
    document.head.appendChild(s);
    const ic = document.createElement("link");
    ic.rel = "stylesheet";
    ic.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(ic);
    return () => { s.remove(); ic.remove(); };
  }, []);

  const STATS = [
    { icon: "bi-hdd-stack", label: "Total Assets", val: stats.total, iconBg: "#eef0f8", iconColor: "#3d4c7a", href: "/allassets" },
    { icon: "bi-check-circle-fill", label: "Available", val: stats.available, iconBg: "#f0fdf4", iconColor: "#16a34a", href: "/allassets" },
    { icon: "bi-person-check-fill", label: "Allocated", val: stats.allocated, iconBg: "#e0f2fe", iconColor: "#0369a1", href: "/allallocations" },
    { icon: "bi-wrench-adjustable", label: "In Repair", val: stats.inRepair, iconBg: "#fffbeb", iconColor: "#d97706", href: "/allmaintenance" },
    { icon: "bi-hourglass-split", label: "Pending Requests", val: pendingCount, iconBg: "#fef2f2", iconColor: "#dc2626", href: "/pendingapprovals" },
  ];

  return (
    <div className="aal-root">
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <AssetModuleNavbar />
      </div>

      <div style={{ padding: "24px 32px 48px", paddingTop: 130 }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 32 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: "#080235", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <i className="bi bi-hdd-stack-fill" style={{ color: "#fff", fontSize: 22 }} />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: "#080235" }}>Asset Management</h1>
            <p style={{ margin: 0, fontSize: 13, color: "#8892a4", marginTop: 2 }}>Overview and quick access to all asset operations</p>
          </div>
        </div>

        {/* Stats */}
        {loading ? <div className="aal-spinner" /> : (
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 36 }}>
            {STATS.map(({ icon, label, val, iconBg, iconColor, href }) => (
              <div className="aal-stat" key={label} onClick={() => href && navigate(href)}
                style={{ cursor: href ? "pointer" : "default" }}>
                <div style={{ width: 44, height: 44, borderRadius: 11, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <i className={`bi ${icon}`} style={{ color: iconColor, fontSize: 20 }} />
                </div>
                <div>
                  <div style={{ fontSize: 26, fontWeight: 700, lineHeight: 1, color: "#1a1f36" }}>{val ?? "—"}</div>
                  <div style={{ fontSize: 11, fontWeight: 500, color: "#8892a4", textTransform: "uppercase", letterSpacing: "0.5px", marginTop: 3 }}>{label}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Quick Links */}
        <div style={{ marginBottom: 36 }}>
          <p style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px", color: "#8892a4", marginBottom: 16 }}>Quick Access</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 14 }}>
            {QUICK_LINKS.map(({ icon, label, href, color, bg }) => (
              <div key={href} className="aal-tile" onClick={() => navigate(href)}>
                <div className="aal-tile-icon" style={{ background: bg }}>
                  <i className={`bi ${icon}`} style={{ color }} />
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#1a1f36" }}>{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Assets */}
        {recent.length > 0 && (
          <div style={{ background: "#fff", border: "1px solid #e8eaf0", borderRadius: 16, overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #f0f2f7", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#1a1f36" }}>Recently Added Assets</p>
              <button onClick={() => navigate("/allassets")} style={{ background: "none", border: "none", fontSize: 12, color: "#080235", fontWeight: 600, cursor: "pointer" }}>View All →</button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: "#f8f9fc" }}>
                    {["Asset Code", "Name", "Category", "Status", "Location"].map(h => (
                      <th key={h} style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 600, color: "#8892a4", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "1px solid #e8eaf0" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {recent.map(a => (
                    <tr key={a.id} onClick={() => navigate(`/viewasset/${a.id}`)}
                      style={{ cursor: "pointer", borderBottom: "1px solid #f0f2f7" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f8f9fc"}
                      onMouseLeave={e => e.currentTarget.style.background = ""}>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ fontFamily: "monospace", fontSize: 12, background: "#eef0f8", color: "#3d4c7a", padding: "2px 8px", borderRadius: 5 }}>{a.assetCode || "—"}</span>
                      </td>
                      <td style={{ padding: "12px 16px", fontWeight: 600, color: "#1a1f36" }}>{a.assetName || "—"}</td>
                      <td style={{ padding: "12px 16px", color: "#5a6482" }}>{a.category || "—"}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{
                          padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600,
                          background: a.status === "Available" ? "#f0fdf4" : a.status === "Allocated" ? "#e0f2fe" : "#fffbeb",
                          color: a.status === "Available" ? "#16a34a" : a.status === "Allocated" ? "#0369a1" : "#d97706",
                        }}>{a.status || "—"}</span>
                      </td>
                      <td style={{ padding: "12px 16px", color: "#8892a4" }}>{a.location || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
